import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  payrolls: [],
  currentPayroll: null,
  loading: false,
  error: null,
  filters: {
    month: null,
    year: null,
    status: null,
    companyId: '',
  },
};

const payrollSlice = createSlice({
  name: 'payroll',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setPayrolls: (state, action) => {
      state.payrolls = action.payload;
    },
    setCurrentPayroll: (state, action) => {
      state.currentPayroll = action.payload;
    },
    updateFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setLoading,
  setError,
  setPayrolls,
  setCurrentPayroll,
  updateFilters,
  clearError,
} = payrollSlice.actions;

export default payrollSlice.reducer;
